<template>
  <div v-if="requestId" id="disbursement-history" class="row">
    <div class="col-12">
      <custom-result-not-found v-if="disbursementHistory.length === 0" />
      <TimeLine v-else class="mt-4">
        <TimeLineItem
          v-for="(item, index) in disbursementHistory"
          :key="index"
          class="custom-time-line rounded"
          icon="fas fa fa-exchange-alt"
        >
          <template #date>
            <div class="date-container ">
              <div class="color-black font-12">Fecha:</div>
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createdDate | date }}
              </div>
              <div class="color-black font-12 font-weight-bold hour">
                {{ formatDate(item.createdDate) }}
              </div>
            </div>
          </template>
          <!-- <template #icon>
            <em class="radius" :class="`fas fa fa-exchange-alt`" />
          </template> -->
          <div class="row pt-4 pb-2 mx-2">
            <div class="row col-12 mb-3">
              <div class="col-md-3">
                <label class="font-18 font-weight-bold ml-2">
                  {{ item.trackingTypeName }}
                </label>
              </div>

              <div class="col col-md-3">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Usuario:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ item.createUserName }}
                </div>
              </div>
              <div class="col col-md-3">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Nombre:
                </div>
                <div class="color-black font-16 font-weight-normal">
                  {{ item.createUserFullName }}
                </div>
              </div>
              <div class="col col-md-3">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Estatus:
                </div>
                <div class="font-16 font-weight-normal">
                  <em
                    class="fa fa-circle font-12 mt-1"
                    :class="`color-${getColorStatus(item.statusId)}`"
                  />
                  <span class="ml-1">{{ item.statusName | empty }}</span>
                </div>
              </div>
            </div>
            <div class="b-card bg-white col-12 p-2">
              <div>
                <i class="fas fa-info-circle text-orange" />
                <span class="pl-2 font-14">Descripción:</span>
              </div>
              <div class="font-16 ml-2">
                <span class="comments">{{ item.description | empty }}</span>
              </div>
            </div>
          </div>
        </TimeLineItem>
      </TimeLine>
      <div class="actions-container container-fluid">
        <action-button
          v-if="showFetchMore"
          class="m-4 pl-5 pr-5 mx-auto outline rounded-pill"
          i="fas fa-angle-down"
          text="Ver más"
          variant="outline-success"
          @click="fetchMoreHistory"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import { parseStateColorByDisbursementStatus } from '@/utils/shared/constants/disbursementRequestStatuses';
import ActionButton from 'ActionButton';
import { getTrackingHistory as _getTrackingHistory } from '@/modules/reinbursement/api.js';
import moment from 'moment';

const DEFAULT_PAGE_SIZE = 3;
const INCREMENT_PAGE_SIZE = 3;

export default {
  name: 'TrackingHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    requestId: { type: [String, Number], default: null },
  },
  data() {
    return {
      disbursementHistory: [],
      showFetchMore: false,
      pageSize: DEFAULT_PAGE_SIZE,
    };
  },
  computed: {
    getColorStatus() {
      return (statusId) => {
        return parseStateColorByDisbursementStatus(statusId);
      };
    },
    incrementSize() {
      return this.disbursementHistory.length + INCREMENT_PAGE_SIZE;
    },
  },
  async mounted() {
    await this.getHistory(1);
  },
  methods: {
    payload(pageIndex) {
      return {
        requestId: this.requestId,
        pageIndex,
        pageSize: this.pageSize,
      };
    },
    formatDate: function(date) {
      if (date) {
        return moment(date)
          .locale('es')
          .format('hh:mm A');
      }
      return '-';
    },
    async fetchMoreHistory() {
      this.pageSize = this.incrementSize;
      await this.getHistory();
    },
    async getHistory(pageIndex = 1) {
      const searchParams = this.payload(pageIndex);

      try {
        const { data: res } = await _getTrackingHistory(searchParams);
        this.disbursementHistory = [...res.data];
        this.showFetchMore = res.count < res.totalItemCount;
      } catch (err) {
        if (err.response != null)
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.comments {
  padding-left: 16px;
}

::v-deep .custom-time-line {
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: #b5c3bc;
    color: #ffffff;
    box-shadow: 0px 3px 6px #00000029;
  }
}

.date-container {
  text-align: right;
}

.actions-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  ::v-deep div.balloon-container {
    display: none !important;
  }

  #circle-badged {
    display: block !important;
  }

  hr {
    display: block !important;
  }
}
</style>
